import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faCalendarAlt, faTags, faPlus, faImage, faSync } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import './EventosData.css';

export default function EventosData() {
    // Pestaña activa ('eventos' o 'categorias')
    const [activeTab, setActiveTab] = useState('eventos');

    // Estados para Eventos
    const [eventos, setEventos] = useState([]);
    const [loadingEventos, setLoadingEventos] = useState(true);
    const [filtroNombre, setFiltroNombre] = useState('');
    const [filtroCategoria, setFiltroCategoria] = useState('');

    // Modal Crear Evento
    const [modalCrearEvento, setModalCrearEvento] = useState(false);
    const [nombreEvento, setNombreEvento] = useState('');
    const [categoriaEvento, setCategoriaEvento] = useState('');
    const [fechaEvento, setFechaEvento] = useState('');
    const [descripcionEvento, setDescripcionEvento] = useState('');
    const [imagenEvento, setImagenEvento] = useState(null);
    const [previewCrear, setPreviewCrear] = useState(null);
    const [guardandoEvento, setGuardandoEvento] = useState(false);

    // Modal Editar Evento
    const [modalEditarEvento, setModalEditarEvento] = useState(false);
    const [eventoAEditar, setEventoAEditar] = useState(null);
    const [editNombre, setEditNombre] = useState('');
    const [editCategoria, setEditCategoria] = useState('');
    const [editFecha, setEditFecha] = useState('');
    const [editDescripcion, setEditDescripcion] = useState('');
    const [editImagen, setEditImagen] = useState(null);
    const [previewEditar, setPreviewEditar] = useState(null);
    const [actualizandoEvento, setActualizandoEvento] = useState(false);

    // Estados para Categorías de Eventos
    const [categorias, setCategorias] = useState([]);
    const [loadingCategorias, setLoadingCategorias] = useState(true);
    const [modalCrearCategoria, setModalCrearCategoria] = useState(false);
    const [nombreNuevaCategoria, setNombreNuevaCategoria] = useState('');
    const [guardandoCategoria, setGuardandoCategoria] = useState(false);

    const [modalEditarCategoria, setModalEditarCategoria] = useState(false);
    const [categoriaAEditar, setCategoriaAEditar] = useState(null);
    const [nombreEditCategoria, setNombreEditCategoria] = useState('');

    useEffect(() => {
        cargarEventos();
        cargarCategorias();
    }, []);

    // ==========================================
    // CARGAS DE DATOS
    // ==========================================
    const cargarEventos = () => {
        setLoadingEventos(true);
        fetch(`${baseURL}/eventosGet.php`, { method: 'GET', credentials: 'include' })
            .then(res => res.json())
            .then(data => {
                setEventos(data.eventos || []);
                setLoadingEventos(false);
            })
            .catch(err => {
                console.error('Error al cargar eventos:', err);
                setLoadingEventos(false);
            });
    };

    const cargarCategorias = () => {
        setLoadingCategorias(true);
        fetch(`${baseURL}/categoriasEventosGet.php`, { method: 'GET', credentials: 'include' })
            .then(res => res.json())
            .then(data => {
                setCategorias(data.categorias || []);
                setLoadingCategorias(false);
            })
            .catch(err => {
                console.error('Error al cargar categorías de eventos:', err);
                setLoadingCategorias(false);
            });
    };

    // ==========================================
    // CRUD EVENTOS
    // ==========================================
    const handleCrearEvento = async (e) => {
        e.preventDefault();
        if (!imagenEvento) {
            toast.error('Debe seleccionar una foto para el evento');
            return;
        }

        setGuardandoEvento(true);
        try {
            const formData = new FormData();
            formData.append('nombre', nombreEvento);
            formData.append('categoria', categoriaEvento);
            formData.append('fecha', fechaEvento);
            formData.append('descripcion', descripcionEvento);
            formData.append('imagen', imagenEvento);

            const res = await fetch(`${baseURL}/eventosPost.php`, {
                method: 'POST',
                credentials: 'include',
                body: formData,
            });

            const data = await res.json();
            if (res.ok && data.mensaje) {
                toast.success(data.mensaje);
                setModalCrearEvento(false);
                setNombreEvento('');
                setCategoriaEvento('');
                setFechaEvento('');
                setDescripcionEvento('');
                setImagenEvento(null);
                setPreviewCrear(null);
                cargarEventos();
            } else {
                toast.error(data.error || 'Error al guardar el evento');
            }
        } catch (err) {
            console.error(err);
            toast.error(err.message || 'Error en la petición');
        } finally {
            setGuardandoEvento(false);
        }
    };

    const abrirModalEditarEvento = (evento) => {
        setEventoAEditar(evento);
        setEditNombre(evento.nombre);
        setEditCategoria(evento.categoria || '');
        setEditFecha(evento.fecha || '');
        setEditDescripcion(evento.descripcion || '');
        setEditImagen(null);
        setPreviewEditar(evento.imagen);
        setModalEditarEvento(true);
    };

    const handleActualizarEvento = async (e) => {
        e.preventDefault();
        if (!eventoAEditar) return;

        setActualizandoEvento(true);
        try {
            const formData = new FormData();
            formData.append('idEvento', eventoAEditar.idEvento);
            formData.append('nombre', editNombre);
            formData.append('categoria', editCategoria);
            formData.append('fecha', editFecha);
            formData.append('descripcion', editDescripcion);
            if (editImagen) {
                formData.append('imagen', editImagen);
            }

            const res = await fetch(`${baseURL}/eventoPut.php`, {
                method: 'POST',
                credentials: 'include',
                body: formData,
            });

            const data = await res.json();
            if (res.ok && data.mensaje) {
                toast.success(data.mensaje);
                setModalEditarEvento(false);
                setEventoAEditar(null);
                cargarEventos();
            } else {
                toast.error(data.error || 'Error al actualizar el evento');
            }
        } catch (err) {
            console.error(err);
            toast.error(err.message || 'Error en la petición');
        } finally {
            setActualizandoEvento(false);
        }
    };

    const eliminarEvento = (idEvento, nombre) => {
        Swal.fire({
            title: '¿Eliminar evento?',
            text: `Se eliminará permanentemente "${nombre}".`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#64748b',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await fetch(`${baseURL}/eventoDelete.php?idEvento=${idEvento}`, {
                        method: 'DELETE',
                        credentials: 'include',
                    });
                    const data = await res.json();
                    if (res.ok && data.mensaje) {
                        Swal.fire('¡Eliminado!', data.mensaje, 'success');
                        cargarEventos();
                    } else {
                        toast.error(data.error || 'Error al eliminar');
                    }
                } catch (err) {
                    console.error(err);
                    toast.error(err.message || 'Error al eliminar');
                }
            }
        });
    };

    // ==========================================
    // CRUD CATEGORÍAS
    // ==========================================
    const handleCrearCategoria = async (e) => {
        e.preventDefault();
        if (!nombreNuevaCategoria.trim()) return;

        setGuardandoCategoria(true);
        try {
            const formData = new FormData();
            formData.append('categoria', nombreNuevaCategoria.trim());

            const res = await fetch(`${baseURL}/categoriasEventosPost.php`, {
                method: 'POST',
                credentials: 'include',
                body: formData,
            });
            const data = await res.json();

            if (res.ok && data.mensaje) {
                toast.success(data.mensaje);
                setModalCrearCategoria(false);
                setNombreNuevaCategoria('');
                cargarCategorias();
            } else {
                toast.error(data.error || 'Error al crear categoría');
            }
        } catch (err) {
            console.error(err);
            toast.error(err.message || 'Error al crear categoría');
        } finally {
            setGuardandoCategoria(false);
        }
    };

    const abrirEditarCategoria = (cat) => {
        setCategoriaAEditar(cat);
        setNombreEditCategoria(cat.categoria);
        setModalEditarCategoria(true);
    };

    const handleActualizarCategoria = async (e) => {
        e.preventDefault();
        if (!categoriaAEditar || !nombreEditCategoria.trim()) return;

        try {
            const res = await fetch(`${baseURL}/categoriaEventoPut.php?idCategoria=${categoriaAEditar.idCategoria}`, {
                method: 'PUT',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ categoria: nombreEditCategoria.trim() }),
            });
            const data = await res.json();

            if (res.ok && data.mensaje) {
                toast.success(data.mensaje);
                setModalEditarCategoria(false);
                setCategoriaAEditar(null);
                cargarCategorias();
            } else {
                toast.error(data.error || 'Error al actualizar categoría');
            }
        } catch (err) {
            console.error(err);
            toast.error(err.message || 'Error al actualizar categoría');
        }
    };

    const eliminarCategoria = (idCategoria, categoria) => {
        Swal.fire({
            title: '¿Eliminar categoría?',
            text: `Se eliminará la categoría "${categoria}".`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#64748b',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await fetch(`${baseURL}/categoriaEventoDelete.php?idCategoria=${idCategoria}`, {
                        method: 'DELETE',
                        credentials: 'include',
                    });
                    const data = await res.json();
                    if (res.ok && data.mensaje) {
                        Swal.fire('¡Eliminada!', data.mensaje, 'success');
                        cargarCategorias();
                    } else {
                        toast.error(data.error || 'Error al eliminar categoría');
                    }
                } catch (err) {
                    console.error(err);
                    toast.error(err.message || 'Error al eliminar');
                }
            }
        });
    };

    // Filtros de eventos
    const eventosFiltrados = eventos.filter(item => {
        const matchNombre = item.nombre.toLowerCase().includes(filtroNombre.toLowerCase());
        const matchCat = !filtroCategoria || item.categoria === filtroCategoria;
        return matchNombre && matchCat;
    });

    return (
        <div>
            <ToastContainer />

            {/* Pestañas de Navegación Superior */}
            <div className='eventosTabs'>
                <button
                    className={`tabBtn ${activeTab === 'eventos' ? 'activeTab' : ''}`}
                    onClick={() => setActiveTab('eventos')}
                >
                    <FontAwesomeIcon icon={faCalendarAlt} /> Eventos ({eventos.length})
                </button>
                <button
                    className={`tabBtn ${activeTab === 'categorias' ? 'activeTab' : ''}`}
                    onClick={() => setActiveTab('categorias')}
                >
                    <FontAwesomeIcon icon={faTags} /> Categorías de Eventos ({categorias.length})
                </button>
            </div>

            {/* ========================================================= */}
            {/* PESTAÑA 1: EVENTOS */}
            {/* ========================================================= */}
            {activeTab === 'eventos' && (
                <div>
                    <div className='eventosHeaderActions'>
                        <button className='btnSave' onClick={() => setModalCrearEvento(true)}>
                            <span>+</span> Nuevo Evento
                        </button>

                        <div className='eventosFiltros'>
                            <input
                                type='text'
                                placeholder='Buscar evento por nombre...'
                                value={filtroNombre}
                                onChange={(e) => setFiltroNombre(e.target.value)}
                            />
                            <select
                                value={filtroCategoria}
                                onChange={(e) => setFiltroCategoria(e.target.value)}
                            >
                                <option value=''>Todas las categorías</option>
                                {categorias.map(c => (
                                    <option key={c.idCategoria} value={c.categoria}>{c.categoria}</option>
                                ))}
                            </select>
                            <button className='btnSave' onClick={cargarEventos} title='Recargar'>
                                <FontAwesomeIcon icon={faSync} />
                            </button>
                        </div>
                    </div>

                    <div className='table-container'>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th>Foto</th>
                                    <th>Nombre del Evento</th>
                                    <th>Categoría</th>
                                    <th>Fecha</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loadingEventos ? (
                                    <tr>
                                        <td colSpan='5' className='emptyState'>Cargando eventos...</td>
                                    </tr>
                                ) : eventosFiltrados.length === 0 ? (
                                    <tr>
                                        <td colSpan='5' className='emptyState'>No se encontraron eventos registrados.</td>
                                    </tr>
                                ) : (
                                    eventosFiltrados.map(item => (
                                        <tr key={item.idEvento}>
                                            <td>
                                                {item.imagen ? (
                                                    <img
                                                        src={item.imagen}
                                                        alt={item.nombre}
                                                        className='imgMiniaturaEvento'
                                                    />
                                                ) : (
                                                    <span>Sin foto</span>
                                                )}
                                            </td>
                                            <td><strong>{item.nombre}</strong></td>
                                            <td>
                                                {item.categoria ? (
                                                    <span className='badgeCategoria'>{item.categoria}</span>
                                                ) : (
                                                    <span style={{ color: '#94a3b8' }}>General</span>
                                                )}
                                            </td>
                                            <td>{item.fecha || item.createdAt?.slice(0, 10) || '-'}</td>
                                            <td>
                                                <button
                                                    className='editar'
                                                    onClick={() => abrirModalEditarEvento(item)}
                                                    title='Editar Evento'
                                                >
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </button>
                                                <button
                                                    className='eliminar'
                                                    onClick={() => eliminarEvento(item.idEvento, item.nombre)}
                                                    title='Eliminar Evento'
                                                >
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {/* ========================================================= */}
            {/* PESTAÑA 2: CATEGORÍAS DE EVENTOS */}
            {/* ========================================================= */}
            {activeTab === 'categorias' && (
                <div>
                    <div className='eventosHeaderActions'>
                        <button className='btnSave' onClick={() => setModalCrearCategoria(true)}>
                            <span>+</span> Nueva Categoría
                        </button>
                        <button className='btnSave' onClick={cargarCategorias} title='Recargar'>
                            <FontAwesomeIcon icon={faSync} />
                        </button>
                    </div>

                    <div className='table-container'>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Categoría</th>
                                    <th>Fecha de Creación</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loadingCategorias ? (
                                    <tr>
                                        <td colSpan='4' className='emptyState'>Cargando categorías...</td>
                                    </tr>
                                ) : categorias.length === 0 ? (
                                    <tr>
                                        <td colSpan='4' className='emptyState'>No hay categorías creadas aún.</td>
                                    </tr>
                                ) : (
                                    categorias.map(item => (
                                        <tr key={item.idCategoria}>
                                            <td>{item.idCategoria}</td>
                                            <td><strong>{item.categoria}</strong></td>
                                            <td>{item.createdAt || '-'}</td>
                                            <td>
                                                <button
                                                    className='editar'
                                                    onClick={() => abrirEditarCategoria(item)}
                                                    title='Editar'
                                                >
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </button>
                                                <button
                                                    className='eliminar'
                                                    onClick={() => eliminarCategoria(item.idCategoria, item.categoria)}
                                                    title='Eliminar'
                                                >
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {/* ========================================================= */}
            {/* MODAL CREAR EVENTO */}
            {/* ========================================================= */}
            {modalCrearEvento && (
                <div className='modal'>
                    <div className='modal-content'>
                        <div className='deFlexBack'>
                            <h4>Nuevo Evento</h4>
                            <span className='close' onClick={() => setModalCrearEvento(false)}>&times;</span>
                        </div>
                        <form onSubmit={handleCrearEvento} id='crearForm'>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Nombre del Evento *</legend>
                                    <input
                                        type='text'
                                        value={nombreEvento}
                                        onChange={(e) => setNombreEvento(e.target.value)}
                                        placeholder='Ej: Conferencia DXN Anual'
                                        required
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Categoría</legend>
                                    <select
                                        value={categoriaEvento}
                                        onChange={(e) => setCategoriaEvento(e.target.value)}
                                    >
                                        <option value=''>Seleccione una categoría</option>
                                        {categorias.map(c => (
                                            <option key={c.idCategoria} value={c.categoria}>{c.categoria}</option>
                                        ))}
                                    </select>
                                </fieldset>

                                <fieldset>
                                    <legend>Fecha del Evento</legend>
                                    <input
                                        type='date'
                                        value={fechaEvento}
                                        onChange={(e) => setFechaEvento(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Foto del Evento *</legend>
                                    <input
                                        type='file'
                                        accept='image/*'
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                                setImagenEvento(file);
                                                setPreviewCrear(URL.createObjectURL(file));
                                            }
                                        }}
                                        required
                                    />
                                    {previewCrear && (
                                        <img src={previewCrear} alt='Preview' className='previewImgUpload' />
                                    )}
                                </fieldset>

                                <fieldset style={{ width: '100%' }}>
                                    <legend>Descripción (Opcional)</legend>
                                    <textarea
                                        rows='3'
                                        value={descripcionEvento}
                                        onChange={(e) => setDescripcionEvento(e.target.value)}
                                        placeholder='Detalles del evento...'
                                        style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                                    />
                                </fieldset>
                            </div>

                            <button type='submit' className='btnPost' disabled={guardandoEvento}>
                                {guardandoEvento ? 'Guardando...' : 'Crear Evento'}
                            </button>
                        </form>
                    </div>
                </div>
            )}

            {/* ========================================================= */}
            {/* MODAL EDITAR EVENTO */}
            {/* ========================================================= */}
            {modalEditarEvento && eventoAEditar && (
                <div className='modal'>
                    <div className='modal-content'>
                        <div className='deFlexBack'>
                            <h4>Editar Evento</h4>
                            <span className='close' onClick={() => setModalEditarEvento(false)}>&times;</span>
                        </div>
                        <form onSubmit={handleActualizarEvento} id='crearForm'>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Nombre del Evento *</legend>
                                    <input
                                        type='text'
                                        value={editNombre}
                                        onChange={(e) => setEditNombre(e.target.value)}
                                        required
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Categoría</legend>
                                    <select
                                        value={editCategoria}
                                        onChange={(e) => setEditCategoria(e.target.value)}
                                    >
                                        <option value=''>Seleccione una categoría</option>
                                        {categorias.map(c => (
                                            <option key={c.idCategoria} value={c.categoria}>{c.categoria}</option>
                                        ))}
                                    </select>
                                </fieldset>

                                <fieldset>
                                    <legend>Fecha del Evento</legend>
                                    <input
                                        type='date'
                                        value={editFecha}
                                        onChange={(e) => setEditFecha(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Foto (Dejar vacía para mantener actual)</legend>
                                    <input
                                        type='file'
                                        accept='image/*'
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                                setEditImagen(file);
                                                setPreviewEditar(URL.createObjectURL(file));
                                            }
                                        }}
                                    />
                                    {previewEditar && (
                                        <img src={previewEditar} alt='Preview' className='previewImgUpload' />
                                    )}
                                </fieldset>

                                <fieldset style={{ width: '100%' }}>
                                    <legend>Descripción</legend>
                                    <textarea
                                        rows='3'
                                        value={editDescripcion}
                                        onChange={(e) => setEditDescripcion(e.target.value)}
                                        style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                                    />
                                </fieldset>
                            </div>

                            <button type='submit' className='btnPost' disabled={actualizandoEvento}>
                                {actualizandoEvento ? 'Guardando...' : 'Guardar Cambios'}
                            </button>
                        </form>
                    </div>
                </div>
            )}

            {/* ========================================================= */}
            {/* MODAL CREAR CATEGORÍA */}
            {/* ========================================================= */}
            {modalCrearCategoria && (
                <div className='modal'>
                    <div className='modal-content'>
                        <div className='deFlexBack'>
                            <h4>Nueva Categoría de Evento</h4>
                            <span className='close' onClick={() => setModalCrearCategoria(false)}>&times;</span>
                        </div>
                        <form onSubmit={handleCrearCategoria} id='crearForm'>
                            <fieldset style={{ width: '100%', marginBottom: '15px' }}>
                                <legend>Nombre de la Categoría *</legend>
                                <input
                                    type='text'
                                    placeholder='Ej: Charlas, Premiaciones, Lanzamientos'
                                    value={nombreNuevaCategoria}
                                    onChange={(e) => setNombreNuevaCategoria(e.target.value)}
                                    required
                                />
                            </fieldset>
                            <button type='submit' className='btnPost' disabled={guardandoCategoria}>
                                {guardandoCategoria ? 'Guardando...' : 'Crear Categoría'}
                            </button>
                        </form>
                    </div>
                </div>
            )}

            {/* ========================================================= */}
            {/* MODAL EDITAR CATEGORÍA */}
            {/* ========================================================= */}
            {modalEditarCategoria && categoriaAEditar && (
                <div className='modal'>
                    <div className='modal-content'>
                        <div className='deFlexBack'>
                            <h4>Editar Categoría de Evento</h4>
                            <span className='close' onClick={() => setModalEditarCategoria(false)}>&times;</span>
                        </div>
                        <form onSubmit={handleActualizarCategoria} id='crearForm'>
                            <fieldset style={{ width: '100%', marginBottom: '15px' }}>
                                <legend>Nombre de la Categoría *</legend>
                                <input
                                    type='text'
                                    value={nombreEditCategoria}
                                    onChange={(e) => setNombreEditCategoria(e.target.value)}
                                    required
                                />
                            </fieldset>
                            <button type='submit' className='btnPost'>
                                Guardar Cambios
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
